import { createBroadcastEvent } from '@h5s/util-broadcast';

/**
 * Evento inviato da una tab attiva in risposta a un `TAB_ACTIVE_REQUEST_EVENT`.
 * Segnala la sua presenza per impedire che un'altra tab, diventata inattiva,
 * forzi un aggiornamento dell'applicazione.
 */
export const TAB_ACTIVE_RESPONSE_EVENT = createBroadcastEvent('TAB_ACTIVE_RESPONSE_EVENT');
